import { Popup } from "antd-mobile";
import React from "react";

export default function IllustratedTutorial(props) {
  const titleDiv = (text) => {
    return (
      <div
        style={{
          color: "red",
          fontSize: 16,
          fontWeight: 500,
          padding: "10px 0",
        }}
      >
        {text}
      </div>
    );
  };

  const item = (text) => {
    return (
      <div
        style={{
          color: "#282828",
          fontSize: 14,
          padding: "10px 0",
          lineHeight: 1.8,
        }}
      >
        {text}
      </div>
    );
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onMaskClick={() => {
          props.onClose();
        }}
        bodyStyle={{
          borderTopLeftRadius: "13px",
          borderTopRightRadius: "13px",
        }}
      >
        <div style={{ overflow: "scroll", maxHeight: "80vh", padding: 20 }}>
          <div
            style={{
              textAlign: "center",
              fontSize: 18,
              color: "#282828",
              fontWeight: 500,
            }}
          >
            iOS 26系统添加书签到主屏幕常见问题
          </div>
          {item(
            "是不是根据提示找不到如何将书签“添加到主屏幕”，如果您的手机是ios26及以上系统，因为该系统的Safari浏览器为用户提供了三种样式的标签页（紧凑、底部、顶部），所以Safari浏览器选择不同的标签页模式，“添加到主屏幕”的操作路径不一样，下面显示不同标签页模式的操作流程：",
          )}
          <div>
            {item("Safari浏览器标签页选择路径：")}
            <div style={{ color: "red", paddingBottom: 15 }}>
              设置-{">"}App-{">"}Safari浏览器-{">"}标签页
            </div>
          </div>
          <img src="resources/20260225/图片 1.png" alt="" />
          {item("Safari浏览器添加书签到主屏幕的操作流程：")}

          {titleDiv("一、紧凑模式")}

          {item("1、点击右下角三个点")}
          <img src="resources/20260225/图片 2.png" alt="" />
          {item("2、再点击共享")}
          <img src="resources/20260225/图片 3.png" alt="" />
          {item("3、往上滑动页面或者点击右下角“更多”")}
          <img src="resources/20260225/图片 4.png" alt="" />
          {item("4、然后点击“添加到主屏幕”，然后点击“添加”即可")}
          <img src="resources/20260225/图片 5.png" alt="" />

          {titleDiv("二、底部模式")}

          {item("1、点击共享按钮")}
          <img src="resources/20260225/图片 6.png" alt="" />
          {item("2、往上滑动页面或者点击右下角“更多”")}
          <img src="resources/20260225/图片 7.png" alt="" />
          {item("3、然后点击“添加到主屏幕”，然后点击“添加”即可")}
          <img src="resources/20260225/图片 8.png" alt="" />

          {titleDiv("三、顶部模式")}

          {item("1、点击共享按钮")}
          <img src="resources/20260225/图片 9.png" alt="" />
          {item("2、往上滑动页面或者点击右下角“更多”")}
          <img src="resources/20260225/图片 10.png" alt="" />
          {item("3、然后点击“添加到主屏幕”，然后点击“添加”即可")}
          <img src="resources/20260225/图片 11.png" alt="" />
        </div>
      </Popup>
    </div>
  );
}
